import { CacheService } from '@absg/angular-common';
import { BaseService, CacheKeys } from '@absg/nim-client-shared';
import { Injectable, OnDestroy } from '@angular/core';
import { CachedResult } from 'shared.root/models/cache-result';

@Injectable({ providedIn: 'root' })
export class BaseStateManagementService extends BaseService implements OnDestroy {
  private defaultTTL = CacheKeys.eightHoursInMinutes;
  constructor(private cacheService: CacheService) {
    super();
  }

  ngOnDestroy(): void {
    this.resetCache();
  }

  getCacheTime(cacheKey: string): Date {
    const timeStampKey = `${cacheKey}${CacheKeys.cacheTimeSuffix}`;
    return this.getCache(timeStampKey, true); // override to null when setting is off
  }

  handleCachingServiceCall(cacheKey: string, result: CachedResult): CachedResult { //TODO: add optional TTL
    if (result.useCache) {
      result.data = this.getCache(cacheKey, true);
      return result;
    } else {
      const timeStamp = `${cacheKey}${CacheKeys.cacheTimeSuffix}`;
      this.setCache(timeStamp, result.clientCacheDateTime, true);
      this.setCache(cacheKey, result.data, true);
      return result;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCache(cacheKey: string, hasExpiry = false): any { // TODO: make private?
    return hasExpiry
      ? this.cacheService.getWithExpiry(cacheKey)?.value
      : this.cacheService.get(cacheKey);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setCache(cacheKey: string, value: any, hasExpiry = false, ttl?: number): any { // TODO: make private?
    return hasExpiry
      ? this.cacheService.setWithExpiry(cacheKey, value, ttl ?? this.defaultTTL)
      : this.cacheService.set(cacheKey, value);
  }

  resetCache(includeExpiry = false): void {
    if (includeExpiry) {
      this.cacheService.clearAll();
    } else {
      this.cacheService.clearAllExceptExpired();
    }
  }

  removeCacheTime(cacheKey: string, hasExpiry = false): void {
    const timeStampKey = `${cacheKey}${CacheKeys.cacheTimeSuffix}`;
    if (hasExpiry) {
      this.cacheService.removeWithExpiry(timeStampKey);
    } else {
      this.cacheService.remove(timeStampKey);
    }
  }
}
